module.exports = __webpack_public_path__ + "img/栋梁铝业.93c08d85.png";